import React from "react";
import "./legal.css";
import Footer from "./Footer";

const Security = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Security</h1>

        <p>KostPadi takes the security of customer information seriously.</p>

        <h2>Security Measures</h2>

        <ul>
          <li>Encrypted HTTPS connections</li>
          <li>Role-based access control</li>
          <li>Secure authentication</li>
          <li>Database access restrictions</li>
          <li>Regular monitoring and logging</li>
          <li>Secure cloud hosting infrastructure</li>
        </ul>

        <h2>Incident Response</h2>

        <p>
          We maintain internal procedures for detecting, investigating, and
          responding to security incidents.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Security;
